import {
  FiUsers,
  FiCreditCard,
  FiFileText,
  FiGift,
  FiDollarSign,
  FiLayers,
  FiClipboard,
  FiActivity,
  FiBarChart2,
  FiMail,
  FiShield,
} from 'react-icons/fi';

/**
 * Ordered pipeline aligned with Subscription-Admin-Routes.js comments.
 */
export const WORKFLOW_STEPS = [
  {
    id: 0,
    key: 'customers',
    title: 'Customers',
    description: 'View subscription users; create on Create User page.',
    subtitle: 'List from /user-details · create on /create-user',
    path: '/admin-subscriptions/customers',
    permission: 'customers:read',
    icon: FiUsers,
    accent: '#8b5cf6',
    externalCreatePath: '/create-user',
  },
  {
    id: 1,
    key: 'plans',
    title: 'Plans',
    description: 'Main and add-on catalog before contracts.',
    subtitle: 'Catalog before contracts',
    path: '/admin-subscriptions/plans',
    permission: 'plans:read',
    icon: FiCreditCard,
    accent: '#0ea5e9',
  },
  {
    id: 2,
    key: 'plan-requests',
    title: 'Plan requests',
    description: 'User paid in app — review and create contracts.',
    subtitle: 'GET /plan-requests',
    path: '/admin-subscriptions/plan-requests',
    permission: 'contracts:read',
    icon: FiClipboard,
    accent: '#14b8a6',
  },
  {
    id: 3,
    key: 'contracts',
    title: 'Contracts',
    description: 'Draft → approve → payment → active pipeline.',
    subtitle: 'user + subscriptionPlanId',
    path: '/admin-subscriptions/contracts',
    permission: 'contracts:read',
    icon: FiFileText,
    accent: '#6366f1',
  },
  {
    id: 4,
    key: 'offers',
    title: 'Offers',
    description: 'Promotions and assign to users or contracts.',
    subtitle: 'Optional promotions',
    path: '/admin-subscriptions/offers',
    permission: 'offers:read',
    icon: FiGift,
    accent: '#f59e0b',
  },
  {
    id: 5,
    key: 'payment',
    title: 'Payment',
    description: 'Razorpay initiate and confirm for a customer.',
    subtitle: 'Razorpay initiate + confirm',
    path: '/admin-subscriptions/payment-setup',
    permission: 'payments:read',
    icon: FiDollarSign,
    accent: '#0d9488',
  },
  {
    id: 6,
    key: 'subscriptions',
    title: 'Subscriptions',
    description: 'Runtime entitlements and usage after activation.',
    subtitle: 'Quota after contract active',
    path: '/admin-subscriptions/subscriptions',
    permission: 'subscriptions:read',
    icon: FiLayers,
    accent: '#ec4899',
  },
  {
    id: 7,
    key: 'invoices',
    title: 'Invoices',
    description: 'List, issue, and download invoice PDFs.',
    subtitle: 'Issue after paid cycle',
    path: '/admin-subscriptions/invoices',
    permission: 'invoices:read',
    icon: FiClipboard,
    accent: '#10b981',
  },
  {
    id: 8,
    key: 'usage',
    title: 'Usage logs',
    description: 'Session and quota consumption history.',
    subtitle: 'GET /usage-logs',
    path: '/admin-subscriptions/operations?tab=usage',
    permission: 'usage:read',
    icon: FiActivity,
    accent: '#06b6d4',
  },
  {
    id: 9,
    key: 'reports',
    title: 'Reports',
    description: 'Revenue, GST, MRR, and contract pipeline.',
    subtitle: 'Revenue, GST, MRR, pipeline',
    path: '/admin-subscriptions/reports',
    permission: 'reports:read',
    icon: FiBarChart2,
    accent: '#3b82f6',
  },
  {
    id: 10,
    key: 'notifications',
    title: 'Notifications',
    description: 'Email logs and resend failed messages.',
    subtitle: 'Logs and resend',
    path: '/admin-subscriptions/operations?tab=notifications',
    permission: 'notifications:read',
    icon: FiMail,
    accent: '#f97316',
  },
  {
    id: 11,
    key: 'audit',
    title: 'Audit',
    description: 'Admin mutation and API change trail.',
    subtitle: 'Mutation trail',
    path: '/admin-subscriptions/operations?tab=audit',
    permission: 'audit:read',
    icon: FiShield,
    accent: '#64748b',
  },
];

export function stepIndexFromPath(pathname, search = '') {
  const path = pathname || '';
  if (path.includes('/customers')) return 0;
  if (path.includes('/plans')) return 1;
  if (path.includes('/plan-requests')) return 2;
  if (path.includes('/contracts')) return 3;
  if (path.includes('/offers')) return 4;
  if (path.includes('/payment-setup')) return 5;
  if (path.includes('/admin-subscriptions/subscriptions')) return 6;
  if (path.includes('/invoices')) return 7;
  if (path.includes('/operations')) {
    if (search.includes('tab=notifications')) return 10;
    if (search.includes('tab=audit')) return 11;
    return 8;
  }
  if (path.includes('/reports')) return 9;
  if (path === '/admin-subscriptions' || path.includes('/workflow')) return -1;
  return -1;
}
